import { FloatingBubbleLayout } from './layouts/FloatingBubbleLayout.jsx'
import { FloatingSearchLayout } from './layouts/FloatingSearchLayout.jsx'
import { OverlayLayout } from './layouts/OverlayLayout.jsx'
import { SlideOutLayout } from './layouts/SlideOutLayout.jsx'
import { InjectedLayout } from './layouts/InjectedLayout.jsx'
import { FullscreenLayout } from './layouts/FullscreenLayout.jsx'
import { resolveEffectiveLayoutKey } from '../../templates/index.js'

const LAYOUTS = {
  'floating-bubble': FloatingBubbleLayout,
  'floating-search': FloatingSearchLayout,
  overlay: OverlayLayout,
  'slide-out': SlideOutLayout,
  injected: InjectedLayout,
  fullscreen: FullscreenLayout,
}

/**
 * Picks the layout component based on the resolved template. Mobile
 * devices always promote slide-out -> fullscreen because the slide-out
 * width animates poorly under iOS Safari soft-keyboard transitions.
 */
export function LayoutManager({ conf, ...rest }) {
  const key = resolveEffectiveLayoutKey(conf)
  const Component = LAYOUTS[key] || LAYOUTS.overlay
  return <Component conf={conf} {...rest} />
}
